/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { useState } from 'react'

import { Flex } from '../../../components/Layout'
import TextModal from '../../../components/Modal/TextModal'
import SuspensionSubmitButton from '../../../components/Suspensions/SuspensionSubmitButton'

const RebuildGameSlots = ({ onSubmit }) => {
  const [loading, setLoading] = useState(false)

  return (
    <TextModal
      title='Rebuild Game Slots'
      link={(toggleOpen) => (
        <SuspensionSubmitButton
          width='180px'
          height='42px'
          css={css`
            margin-left: 16px;
          `}
          onClick={toggleOpen}
        >
          Rebuild Game Slots
        </SuspensionSubmitButton>
      )}
    >
      {(toggleOpen) => {
        return (
          <form
            method='GET'
            action='/'
            onSubmit={async (e) => {
              e.preventDefault()
              setLoading(true)
              await onSubmit()
              setLoading(false)
              toggleOpen()
            }}
          >
            <p
              css={css`
                margin-bottom: 16px !important;
              `}
            >
              Are you sure you want to rebuild game slots?
            </p>
            <p>
              This will update initial placement if you have re-seeded or
              added/removed teams from this division.
            </p>
            <Flex
              alignItems='center'
              justifyContent='space-between'
              css={css`
                margin-top: 32px;

                .cancel {
                  border-color: white;
                }
              `}
            >
              <SuspensionSubmitButton
                disabled={loading}
                className='cancel'
                type='button'
                onClick={() => {
                  toggleOpen()
                }}
              >
                Cancel
              </SuspensionSubmitButton>
              <SuspensionSubmitButton
                busy={loading}
                disabled={loading}
                isSolid
                css={css`
                  margin-left: 32px;
                `}
                type='submit'
              >
                Rebuild
              </SuspensionSubmitButton>
            </Flex>
          </form>
        )
      }}
    </TextModal>
  )
}

export default RebuildGameSlots
